module.exports = __webpack_public_path__ + "static/h2-c627e4db528e3c7e143d1a24635929a3.png";